<template>
  <Modal
    :visible="visible"
    @close="visible = false"
  >
    <iframe class="Modal-iframe" ref="iframe"></iframe>
  </Modal>
</template>

<script>

export default {
  name: 'IframeModal',
  components: {
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
  },
  methods: {
    show(src) {
      this.visible = true
      this.$refs.iframe.src = 'data:text/html;charset=utf-8,' + escape(src)
    },
    confirm() {
      this.visible = false
    }
  }
};
</script>

<style lang="less" scoped>
.Modal-iframe {
  width: 100%;
  height: 520px;
}
</style>
